import ConfigView           from 'scripts/defa/basic/view-config-view';
import SuccessView          from 'scripts/defa/basic/view-success-view';
import CustomerContainer    from 'scripts/defa/customers/view-customer-container';
import UnitTestFlow         from 'scripts/defa/unit-tests/view-unit-test-flow';
import Unit                 from 'scripts/defa/units/model-unit';
import UnitSearchSerialForm from 'scripts/defa/units/view-unit-search-serial-form';
import Flow                 from 'scripts/poppet/flow';
import template             from 'templates/unitComplaintFlow.jst.html';

const channelUser   = Bb.Radio.channel( 'user' ),
	channelLayout = Bb.Radio.channel( 'layout' ),
	channel       = Bb.Radio.channel( 'objects' );

const selectors = {
	container: '[data-region=complaint-container]',
};

/**
 * defa.views.UnitComplaintFlow
 * A flow for changing one unit with another under one subscription.
 * @version 1.2.1
 */

const UnitComplaintFlow = Flow.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	className: 'card',
	
	regions: {
		container: selectors.container,
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when a childView requests to open an installer.
	 * @param {int} id  The ID of the installer.
	 * @void
	 */
	onChildviewInstallerOpen: function ( id ) {
		this.installer = id;
		this.dispatch();
	},
	
	/**
	 * Triggers when a childView informs that the new unit has been tested.
	 * @void
	 */
	onChildviewUnitTested: function () {
		this.unitTest = true;
		this.dispatch();
	},
	
	/**
	 * Triggers when a successView asks to close up.
	 * @param {view} childView  The view where the event originated from.
	 * @void
	 */
	onChildviewSuccessClose: function ( childView ) {
		childView.animateOut();
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Dispatches the change unit flow, selects unit, tests unit, selects installer, changes unit.
	 * @void
	 */
	dispatch: function () {
		// setup
		this.unit      = this.unit || false;
		this.unitTest  = this.unitTest || false;
		this.installer = this.installer || false;
		
		
		// order
		let fn = false;
		
		// no unit set
		if ( !this.unit ) {
			fn = this._showUnitSearch;
		}
		
		// unit not tested
		if ( this.unit && !this.unitTest ) {
			fn = this._showUnitTest;
		}
		
		if ( this.unit && this.unitTest && !this.installer ) {
			fn = this._showSelectInstaller;
		}
		
		if ( this.unit && this.unitTest && this.installer ) {
			fn = this._changeUnit;
		}
		
		// fn call
		if ( _.isFunction( fn ) ) {
			fn.call( this );
		}
	},
	
	// dispatch steps
	
	/**
	 * Shows the unit search view.
	 * @void
	 */
	_showUnitSearch: function () {
		
		let unit           = new Unit();
		let unitSearchView = new UnitSearchSerialForm( {
			model  : unit,
			context: 'replace',
			help   : false,
		} );
		
		this.listenToOnce( unit, 'sync', function () {
			this.unit = unit;
			this.dispatch();
		} );
		
		this.showChildView( 'container', unitSearchView );
	},
	
	/**
	 * Shows the unit test layout
	 * @void
	 */
	_showUnitTest: function () {
		
		let unitTestFlow = new UnitTestFlow( {
			model: this.unit,
		} );
		
		this.showChildView( 'container', unitTestFlow, false );
	},
	
	/**
	 * Shows the installer select option, (or autoselects if there is only one installer account )
	 * @void
	 */
	_showSelectInstaller: function () {
		
		// vars
		let user       = channelUser.request( 'model' ),
			customers  = user.getCustomers(),
			installers = [];
		
		// get installers
		if ( 'AUTOMOTIVE' === this.unit.get( 'family' ) ) {
			installers = customers.filterByRoles( [ 'INSTALLER_AUTOMOTIVE', ] );
		}
		
		if ( 'HOME' === this.unit.get( 'family' ) ) {
			installers = customers.filterByRoles( [ 'INSTALLER_HOME', ] );
		}
		
		// autoselect single installers
		if ( 1 === installers.length ) {
			this.installer = installers.models[ 0 ].get( 'id' );
			this.dispatch();
			
			// or choose from more than one installer
		} else {
			
			let customerContainer = new CustomerContainer( {
				view      : 'customer:list',
				user      : this.user,
				context   : 'installer',
				create    : false, // disables the options to create a new customer.
				customers : installers,
				navHandler: 'internal',
			} );
			
			this.showChildView( 'container', customerContainer );
		}
	},
	
	// subscription functions
	
	/**
	 * Does the actual change unit function.
	 * @void
	 */
	_changeUnit: function () {
		
		// show config-view
		let configView = new ConfigView( {
			context: 'wait',
		} );
		this.showChildView( 'container', configView );
		
		// the successView gets the updated installed units closelink.
		this.listenToOnce( this.model, 'sync', function () {
			channel.request( 'units' ).add( this.model, { merge: true } );
			
			let successView = new SuccessView( {
				context  : 'unit:complaint',
				closeLink: {
					event : 'unit:installed:selected',
					params: [ this.installer, 1 ],
				},
			} );
			
			this.showChildView( 'container', successView );
		} );
		
		// listen for change error
		this.listenToOnce( this.model, 'error', function ( model, response ) {
			channelLayout.trigger( 'error', response.responseJSON );
		} );
		
		// perform the change, cait.
		this.model.complaint( {
			transientInstallerId: this.installer,
			transientNewUnit    : this.unit.get( 'id' ),
		} );
	},
	
} );

export default UnitComplaintFlow;